// NOTE: Mutates relationships argument
export function extractRelationshipGroup(relationships, options) {
  const availableRelationships = relationships.filter((relationship) => {
    return options.values.includes(relationship.value);
  });

  for (let i = relationships.length - 1; i >= 0; i--) {
    if (availableRelationships.includes(relationships[i])) {
      relationships.splice(i, 1);
    }
  }

  return {
    ...options,
    availableRelationships
  };
}

export function getRelationshipsInGroups(relationshipGroups) {
  return relationshipGroups
    .flatMap(group => group.availableRelationships)
    .map(relationship => relationship.value);
}

export function filterContactRoles(contactRoles, { only, except }) {
  return contactRoles.filter((contactRole) => {
    if (contactRole._destroy) {
      return false;
    }

    return except
      ? !except.includes(contactRole.role)
      : only.includes(contactRole.role);
  });
}
